// Dependencies
import {
  REPARTIDORES_REQUEST,
  REPARTIDORES_REFRESH,
  REPARTIDORES_OK,
  REPARTIDORES_ERROR
} from "./types";

const initialState = {
  qty: null,
  data: [],
  loading: false,
  error: false,
  refreshing: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REPARTIDORES_REQUEST:
      return { ...state, loading: true };
    case REPARTIDORES_REFRESH:
      return { ...state, refreshing: true };
    case REPARTIDORES_ERROR:
      return {
        ...state,
        refreshing: false,
        loading: false,
        error: action.payload.error
      };
    case REPARTIDORES_OK:
      return {
        ...state,
        refreshing: false,
        loading: false,
        data: action.payload.data,
        qty: action.payload.qty
      };
    default:
      return {
        ...state
      };
  }
};

export default reducer;
